export default __webpack_public_path__ + "static/media/rating.2ce35103.svg";